import { createAsyncThunk } from "@reduxjs/toolkit";
import { SLICE_NAME } from "utils/constants";

import { adminSignInApi } from "./services";

export const adminSignIn = createAsyncThunk(
  `${SLICE_NAME.adminSignInSlice}/adminSignIn`,
  async (body, { rejectWithValue }) => {
    try {
      const response = await adminSignInApi.signIn(body);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getUsersInfo = createAsyncThunk(
  `${SLICE_NAME.adminSignInSlice}/getUsersInfo`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await adminSignInApi.getUserInfo();
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const profileThunk = (name, call) =>
  createAsyncThunk(`${SLICE_NAME.adminSignInSlice}/${name}`, async (arg, { rejectWithValue }) => {
    try {
      const response = await call(arg);

      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  });

// Both of these answer with the same GetUserByTokenResource `me` returns, so the
// reducers merge the response into userInfo instead of re-fetching it. A refetch
// would race the page's own load: the axios interceptor de-dupes by method_url
// and cancels the in-flight duplicate.
export const updateProfile = profileThunk("updateProfile", (body) => adminSignInApi.updateProfile(body));
export const updateAvatar = profileThunk("updateAvatar", (file) => adminSignInApi.updateAvatar(file));
export const changePassword = profileThunk("changePassword", (body) => adminSignInApi.changePassword(body));
export const getMyActivity = profileThunk("getMyActivity", (params) => adminSignInApi.getMyActivity(params));
export const getMyActivityDay = profileThunk("getMyActivityDay", (params) => adminSignInApi.getMyActivityDay(params));

export const getNotifications = createAsyncThunk(
  `${SLICE_NAME.adminSignInSlice}/getNotifications`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await adminSignInApi.getNotifications();
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const deleteNotification = createAsyncThunk(
  `${SLICE_NAME.adminSignInSlice}/deleteNotification`,
  async (id, { rejectWithValue }) => {
    try {
      const response = await adminSignInApi.deleteNotification(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const readAllNotifications = createAsyncThunk(
  `${SLICE_NAME.adminSignInSlice}/readAllNotifications`,
  async (body, { rejectWithValue }) => {
    try {
      const response = await adminSignInApi.readAllNotifications(body);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
